module.exports = __webpack_public_path__ + "img/1548870527.b9eec05a.jpg";